<mat-card>
  <mat-toolbar>{{title}}
    <span class="fill-remaining-space"></span>
    <button mat-icon-button matTooltip="{{ 'oportunitats.filtre' | translate }}" attr.aria-label="{{ 'oportunitats.filtre' | translate }}" matTooltipClass="tooltip-style" (click)="toggleFiltersVisibility()" style="float: right; margin-left:10px;margin-right: 0">
        <mat-icon color="primary" style="font-size:24px">filter_list</mat-icon>
    </button>
    <button mat-icon-button matTooltip="{{ 'ticketingList.exportarToolTip' | translate }}" attr.aria-label="{{ 'ticketingList.exportarToolTip' | translate }}" matTooltipClass="tooltip-style" (click)="this.export()" style="float: right; margin-left:10px;margin-right: 0">
           <mat-icon color="primary" style="font-size:24px">assignment_returned</mat-icon>
    </button>
    <button mat-icon-button (click)="addTicket()" color="primary" matTooltip="{{ 'ticketingList.afegirToolTip' | translate }}" attr.aria-label="{{ 'ticketingList.afegirToolTip' | translate }}" matTooltipClass="tooltip-style" style="float: right; margin-left:10px;margin-right: 0">
           <mat-icon color="primary" style="font-size:24px">note_add</mat-icon>
    </button>
  </mat-toolbar>
  <mat-card-content>
    <mcrit-gestio-ticketing-filtres
      *ngIf="showFilters"
      [validFilters]="validFilters"
      (changeFilter)="computeActiveFilters($event)"
      >
    </mcrit-gestio-ticketing-filtres>
    <table style="width: 100%">
      <thead>
        <tr>
          <th style="width:10px">&nbsp;</th>
          <th style="width:10%;text-align: center" (click)="cycleOrdering('data_peticio')">{{ 'ticketingDialog.dataPeticio' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                orderingParameters['data_peticio'] === 1?'keyboard_arrow_up':(orderingParameters['data_peticio'] === 2?'keyboard_arrow_down':'')
              )}}
            </mat-icon>
          </th>
          <th style="width:10%;text-align: center" (click)="cycleOrdering('tipus')">{{ 'propostaMi.camps.tipus' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['tipus'] === 1 ?'keyboard_arrow_up' :(orderingParameters['tipus'] === 2 ?'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th style="width:10%;text-align: center" (click)="cycleOrdering('sub_tipus')">{{ 'ticketingDialog.subTipus' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['sub_tipus'] === 1 ?'keyboard_arrow_up' :(orderingParameters['sub_tipus'] === 2 ?'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th style="width:10%;text-align: center" (click)="cycleOrdering('nom')">{{ 'ticketingList.colUsuari' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['nom'] === 1 ?'keyboard_arrow_up' :(orderingParameters['nom'] === 2 ?'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th style="width:25%;text-align: center" (click)="cycleOrdering('assumpte')">{{ 'seguimentTecnic.colAssumpte' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['assumpte'] === 1 ?'keyboard_arrow_up' :(orderingParameters['assumpte'] === 2 ?'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th style="width:10%;text-align: center" (click)="cycleOrdering('data_acord')">{{ 'ticketingDialog.dataAcceptacio' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['data_acord'] === 1 ?'keyboard_arrow_up' :(orderingParameters['data_acord'] === 2 ?'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th style="width:10%;text-align: center" (click)="cycleOrdering('data_denegacio')">{{ 'ticketingDialog.dataDenegacio' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['data_denegacio'] === 1 ?'keyboard_arrow_up' :(orderingParameters['data_denegacio'] === 2 ?'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th style="width:10%;text-align: center" (click)="cycleOrdering('data_realitzacio')">{{ 'ticketingDialog.dataRealitzacio' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['data_realitzacio'] === 1 ?'keyboard_arrow_up' :(orderingParameters['data_realitzacio'] === 2 ?'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
         </tr>
      </thead>
 <tbody *ngIf="elementList">
  <tr *ngFor="let ticketing of elementList.rows; let j = index" 
      (click)="editTicket(ticketing)" 
      class="ticket-row"
      [class.odd]="j % 2 !== 0">
      
    <td class="status-col">
      <mat-icon *ngIf="pendentRealitzar(ticketing.data_acord, ticketing.data_denegacio, 3)" 
                style="color:red" title="{{ 'ticketingList.denegadaTitle' | translate }}">error</mat-icon>
      <mat-icon *ngIf="pendentRealitzar(ticketing.data_acord, ticketing.data_realitzacio, 0)" 
                style="color:#1159A9" title="{{ 'ticketingList.potRealitzarTitle' | translate }}">play_circle</mat-icon>
      <mat-icon *ngIf="pendentRealitzar(ticketing.data_acord, ticketing.data_denegacio, 2)" 
                style="color:orange;" title="{{ 'ticketingList.pendentAcceptarTitle' | translate }}">pending</mat-icon>
      <mat-icon *ngIf="pendentRealitzar(ticketing.data_acord, ticketing.data_realitzacio, 1)" 
                style="color:green" title="{{ 'seguimentTecnicList.tascaRealitzada' | translate }}">check_circle</mat-icon>
    </td>

    <td class="text-center">{{ ticketing.data_peticio | date:'dd/MM/yyyy' }}</td>
    <td class="text-center">{{ ticketing.tipus }}</td>
    <td class="text-center">{{ ticketing.sub_tipus }}</td>
    <td class="text-center">{{ ticketing.personal_id }}</td>
    <td class="text-right">{{ ticketing.assumpte }}</td>
    <td class="text-center">{{ ticketing.data_acord }}</td>
    <td class="text-center">{{ ticketing.data_denegacio }}</td>
    <td class="text-center">{{ ticketing.data_realitzacio }}</td>
  </tr>
</tbody>
    </table>
  </mat-card-content>
  <mat-toolbar class="footer">
    <span class="fill-remaining-space"></span>
    <span style="padding-right: 1em">
      {{ 'facturesRebList.liniesPag' | translate }}: {{listService.rowsPerPage}}
      <button mat-icon-button [mat-menu-trigger-for]="menuNumberRows">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </span>
    <span style="padding-right: 1em" *ngIf="elementList">
      {{ 'facturesRebList.resumRegistres' | translate:{ first: firstRegisterShown, last: lastRegisterShown, total: elementList.registers } }}
    </span>
    <button mat-icon-button (click)="gotoPage(0)">
      <mat-icon>first_page</mat-icon>
    </button>
    <button mat-icon-button (click)="requestPrevious()">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button mat-icon-button (click)="requestNext()">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </mat-toolbar>
</mat-card>
<mat-menu #menuNumberRows y-position="above">
    <button mat-menu-item *ngFor="let value of rowsPerPageOptions" (click)="setRowPerPage(value)">{{value}}</button>
</mat-menu>
